// The seller as named in every legal text (same details as TopluMail's legal
// pages). PAYTR and the Distance Contracts Regulation require the address.
export const SELLER = {
  name: 'Utku Tamer Göktaş',
  tradeName: 'Martinci İmza Yönetim Portalı',
  taxNumber: '4060564940',
  taxOffice: 'Göztepe Vergi Dairesi',
  address: 'Fenerbahçe Mah. Igrıp Sk. No: 13 İç Kapı No: 1, Kadıköy/İstanbul',
  phone: '+90 850 840 83 31',
  kep: 'utkutamer.goktas@hs01.kep.tr',
  email: 'destek@martinci.com',
  website: 'https://imza.martinci.com',
};
